<template>
  <div class="word-wrap">
    <div id="wordView" class="word-wrap-content" v-html="wordText"></div>
  </div>
</template>

<script>
import mammoth from "mammoth";
import * as url from 'url'
export default {
  data() {
    return {
      wordText: "",
    };
  },
  computed: {
    filePath() { return this.$route.params.file || '文件不存在'; },
  },
  created() {
    this.getWordText();
  },
  methods: {
    getWordText() {
      let filePath = `../file/${this.filePath}`;
      console.log(this.$route.params);
      console.log(filePath);
      const xhr = new XMLHttpRequest();
      xhr.open("get", filePath, true);
      xhr.responseType = "arraybuffer";
      xhr.onload = () => {
        if (xhr.status == 200) {
          mammoth.convertToHtml({ arrayBuffer: new Uint8Array(xhr.response) }).then((resultObject) => {
            this.$nextTick(() => {
              this.wordText = resultObject.value;
            });
          });
        }
      };
      xhr.send();
    }
  },
};
</script>

<style lang="less">
.word-wrap {
  padding: 15px;
  align-content: center;
  .word-wrap-content{
    max-width: 800px;
    margin:0 auto;
    font-size: 18px;
    color: #1a1a1a;
    h1,h2,h3,h4,h5,h6{font-size:100%;font-weight:bold;}
    img {
      width: 60%;
    }
  }
}
</style>